import React from "react";
import { MopMenuItem } from '../store/MenuStoreTypes';
import './CategoryFilters.scss';

const CategoryFilters: React.FC<{ menuItems: MopMenuItem[], selectedFilter: string | undefined | null, onFilterSelected: (selectedFilter: string) => void }> = ({ menuItems, selectedFilter = "", onFilterSelected }) => {
    const matchingMenuItems = menuItems
        .filter((menuItem: MopMenuItem) => menuItem.categoryLevelFilter)
        .sort((a: MopMenuItem, b: MopMenuItem) => (
             (b.sortOrder ?? 0) - (a.sortOrder ?? 0)
        ));

    const uniqueFilters = matchingMenuItems
        .map(item => item.categoryLevelFilter)
        .filter((value, index, array) => array.indexOf(value) === index);

    return (
        <div className="filterContainer">
            <div className="filterSlider">
                {uniqueFilters.length > 1 && (
                    <div
                        onClick={() => selectedFilter !== "" && onFilterSelected("")}
                        className={"filterButton" + ("" === selectedFilter ? " selectedFilter" : "")}
                        key={"All_Selected"}
                    >
                        All
                    </div>
                )}
                {uniqueFilters.length > 1 && uniqueFilters.map((value: string, index: number) => (
                    <div
                        onClick={() => selectedFilter !== value && onFilterSelected(value)}
                        className={"filterButton" + (value === selectedFilter ? " selectedFilter" : "")}
                        key={"JACK" + index}
                    >
                        {value}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryFilters;
